import React from 'react'
import './Common_title.css'

const Common_title = (props) => {
  return (
    <>
        <div className={props.className}>
            <h3 className='commontitle'>{props.title}</h3>
            <p className='commonsubtitle'>{props.subtitle}</p>
        </div>
    </>
  )
}

export default Common_title